"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.take = void 0;
const slice_1 = require("./slice");
exports.take = (iterable, amount = 1) => slice_1.slice(iterable, 0, amount);
//# sourceMappingURL=take.js.map